/* src/app/core/loading/loading.component.scss */
.spinner-container {
  position: fixed;
  background: rgba(0, 0, 0, 0.32);
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  z-index: 6000;
}
/*# sourceMappingURL=loading.component-TWAZSIQW.css.map */
